// 方案一：深蓝色系 - 专业、可信、稳重（推荐）
// 适合：专业职业测评平台，类似LinkedIn风格
export const professionalBlueTheme = {
  colors: {
    'psychology-primary': '#2563EB',      // 深蓝色 - 专业、可信、稳重
    'psychology-secondary': '#1E40AF',    // 更深蓝色 - 辅助色，增强专业感
    'psychology-accent': '#3B82F6',       // 亮蓝色 - 强调色，活力但不失专业
    'psychology-calm': '#EFF6FF',         // 极浅蓝色 - 背景色，清新专业
    'psychology-warm': '#DBEAFE',         // 浅蓝色 - 温暖背景，柔和
    'psychology-success': '#10B981',      // 绿色 - 成功、积极
    'psychology-info': '#3B82F6',         // 蓝色 - 信息状态
    'psychology-warning': '#F59E0B',      // 橙色 - 警告状态
  },
  name: 'professional-blue',
  description: '深蓝色系主题 - 专业、可信、稳重，适合职业测评平台'
}

